import React from 'react';
import { motion } from 'framer-motion';
const ComingSoon = () => {
  return <motion.div className="absolute inset-0 flex items-center justify-center bg-white/30 backdrop-blur-xl z-30" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} data-id="element-69">
      <p className="text-lg md:text-xl font-medium text-gray-800/90" data-id="element-70">
        Coming Soon
      </p>
    </motion.div>;
};
export default ComingSoon;